import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuthenticationService } from "../../auth/service";

@Injectable({
  providedIn: "root",
})
export class TaskService {
  public list: any[] = [];

  public mine: any[] = [];

  constructor(
    private _httpClient: HttpClient,
    private _authService: AuthenticationService,
  ) {}

  async all() {
    return this._httpClient
      .get("/task")
      .toPromise()
      .then(async (result: any) => {
        this.list = result;
        return result;
      });
  }

  async getMine() {
    const myHash: any = this._authService.getCurrentUser().hash;
    return this._httpClient
      .get("/me/task")
      .toPromise()
      .then(async (result: any) => {
        await Promise.all(
          result.map((res: any, index: number) => {
            if (res.users.filter((user: any) => user.hash === myHash).length > 0) {
              result[index].view_because = "assigned_to_me";
            } else if (res.creator.hash === myHash) {
              result[index].view_because = "have_assigned";
            } else if (this._authService.hasCapability("task_view_others")) {
              result[index].view_because = "have_capability";
            }
          }),
        );
        this.mine = result;
        return result;
      });
  }

  async create(data: any) {
    return this._httpClient
      .post("/task", data)
      .toPromise()
      .then((result: any) => {
        this.getMine();
        return result;
      });
  }

  async get(id: number) {
    return this._httpClient.get(`/task/${id}`).toPromise();
  }

  async update(id: number, data: any = {}) {
    return this._httpClient
      .put(`/task/${id}`, data)
      .toPromise()
      .then(async (result: any) => {
        await this.getMine();
        return result;
      });
  }

  async remove(id: number) {
    return this._httpClient
      .delete(`/task/${id}`)
      .toPromise()
      .then(async (result: any) => {
        await this.getMine();
        return result;
      });
  }

  async removeAttachments(id: number) {
    return this._httpClient.delete(`/task/attachment/${id}`).toPromise();
  }

  async setToDo(id: number) {
    return this._httpClient.put(`/task/todo/${id}`, {}).toPromise();
  }

  async setTaken(id: number) {
    return this._httpClient.put(`/task/taken/${id}`, {}).toPromise();
  }

  async setCompleted(id: number) {
    return this._httpClient.put(`/task/complete/${id}`, {}).toPromise();
  }

  async sendComment(args: any) {
    return this._httpClient.post("/task/comment", args).toPromise();
  }

  async removeComment(id: number) {
    return this._httpClient.delete(`/task/comment/${id}`).toPromise();
  }
}
